import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import ItemBox from './index';
import './styles.scss';

const itemBoxList = props => {
  const { services } = props;

  return (
    <div className="item-box-container" role="tablist">
      <Row className="no-gutters">
        {services.map((item, key) => (
          <Col md={12} lg={6} xl={4} key={key} className={'padding-bottom'}>
            <ItemBox
              title={item.name}
              description={item.description}
              icon={item.icon}
              children={
                item.franchise && <div className="offer-service-franchise">{item.franchise}</div>
              }
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

itemBoxList.propTypes = {
  services: PropTypes.array.isRequired,
};

export default itemBoxList;
